import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { dashboardsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { Dashboard } from "@src/types/dashboards";

export const getDashboardByIdV2 = async (
  namespace: string,
  dashboardId: string,
): Promise<{ data: Dashboard }> => {
  const url = dashboardsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<Dashboard>(
      `${url}/api/v2/ns/${namespace}/dashboards/${dashboardId}`,
      { headers },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    }
    throw new Error("An unexpected error occurred while fetching dashboard.");
  }
};
